'use client';

import { cn } from '@/lib/utils';

interface TextCardProps {
  element: {
    props: {
      title: string;
      content: string;
      variant: 'info' | 'warning' | 'success' | 'tip';
    };
  };
}

const variantStyles = {
  info: 'bg-blue-50 border-blue-200 dark:bg-blue-950/20 dark:border-blue-800',
  warning: 'bg-amber-50 border-amber-200 dark:bg-amber-950/20 dark:border-amber-800',
  success: 'bg-green-50 border-green-200 dark:bg-green-950/20 dark:border-green-800',
  tip: 'bg-purple-50 border-purple-200 dark:bg-purple-950/20 dark:border-purple-800',
};

const variantIcons = {
  info: 'ℹ️',
  warning: '⚠️',
  success: '✅',
  tip: '💡',
};

// TextCard doesn't need fullscreen - it's a simple callout
export function TextCard({ element }: TextCardProps) {
  if (!element?.props) {
    return <div className="p-4 border rounded-lg bg-muted/30 text-muted-foreground">Loading...</div>;
  }
  
  const { title, content, variant } = element.props;

  return (
    <div className={cn(
      'w-full p-5 border-2 rounded-xl',
      variantStyles[variant]
    )}>
      <div className="flex items-center gap-3 mb-3">
        <span className="text-2xl">{variantIcons[variant]}</span>
        <h3 className="font-bold text-lg">{title}</h3>
      </div>
      <div className="prose prose-sm dark:prose-invert max-w-none leading-relaxed">
        {content}
      </div>
    </div>
  );
}
